import {useRouter} from 'next/router';
import {useMemo} from 'react';

export const useIsHotelIndependentPage = () => {
  const router = useRouter();

  return useMemo(() => {
    return router.pathname.includes('/gestion');
  }, [router.pathname]);
};
